<rt-box [hasHoverState]="true" variant="padding-small">
  <rt-icon [name]="icon" [color]="iconColor" size="medium" margin-right></rt-icon>
  <div layout-vertical layout-flex-1-1>
    <div>
      <rt-heading>{{ heading }}</rt-heading>
      <rt-badge
        *ngIf="badgeText"
        [color]="badgeVariant"
        [text]="badgeText"
        margin-left-small-x
      ></rt-badge>
    </div>
    <rt-heading variant="subheading normal">{{ subheading }}</rt-heading>
  </div>
  <div>
    <rt-icon [name]="'chevron-right'" class="arrow-icon"></rt-icon>
  </div>
</rt-box>
